import React from "react";

export const AllWidgetsContext = React.createContext({});
